// @flow
import React from 'react'
import {
  Error,
  FormField,
  Label,
  StyledField,
  StyledInput,
  SecondLabel,
  DisabledSuffix
} from 'src/components/Form'
import type { Field as FieldProps } from 'src/types'

const renderField = ({
  className,
  input,
  label,
  id,
  secondLabel,
  type,
  options,
  disabled,
  disabledSuffix,
  placeholder,
  autocomplete,
  altError,
  noMargin,
  pushSuffix,
  meta: { touched, error }
}: FieldProps) => (
  <FormField className={className} noMargin={noMargin}>
    <Label>{label}</Label>
    <SecondLabel> {secondLabel}</SecondLabel>
    <StyledField hasError={touched && error}>
      <StyledInput
        {...input}
        pushSuffix
        disabled={disabled}
        className="input"
        placeholder={placeholder}
        options={options}
        type={type}
        id={id}
        autoComplete={autocomplete}
      />
      {disabled && input.value && (
        <DisabledSuffix pushSuffix={pushSuffix}>{disabledSuffix}</DisabledSuffix>
      )}
      {touched && error && (
        <Error>
          {error === 'Required'
            ? `Oh, you need to type your ${`${altError || label}`.toLowerCase()} here to continue`
            : error}
        </Error>
      )}
    </StyledField>
  </FormField>
)

export default renderField



// WEBPACK FOOTER //
// ./src/helpers/fieldRenderers/Field.js